var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransferRightArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#8fbcff",
    d: "M275.695 268.434 102.477 441.676c-6.875 6.879-18.02 6.879-24.895.004l-42.86-42.86c-6.87-6.875-6.874-18.02 0-24.894l117.915-117.938-69.121-69.125-48.79-48.789c-6.874-6.875-6.874-18.02 0-24.894l42.856-42.86c6.875-6.875 18.02-6.875 24.895 0l173.218 173.22c6.875 6.874 6.875 18.019 0 24.894zm0 0",
    opacity: 1,
    "data-original": "#76ffd9",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0066ff",
    d: "m220.363 188.262-67.754 67.754-25.894-25.899-43.2-43.254-48.788-48.789c-6.875-6.875-6.875-18.02 0-24.894l42.851-42.856c6.879-6.875 18.027-6.875 24.902.004l91.985 92.035zm0 0",
    opacity: 1,
    "data-original": "#00c395",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5197ff",
    d: "m220.363 188.262-67.754 67.754-16.43-16.457 67.755-67.754zm0 0",
    opacity: 1,
    "data-original": "#5de0bf",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0066ff",
    d: "M456.297 268.434 283.078 441.676c-6.875 6.879-18.023 6.879-24.898.004l-42.856-42.86c-6.875-6.875-6.875-18.02-.004-24.894l117.914-117.938-69.12-69.125-48.79-48.789c-6.875-6.875-6.875-18.02 0-24.894l42.856-42.86c6.875-6.875 18.023-6.875 24.898 0l173.219 173.22c6.875 6.874 6.875 18.019 0 24.894zm0 0",
    opacity: 1,
    "data-original": "#00c395",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8fbcff",
    d: "m400.96 188.262-67.75 67.754-25.897-25.899-43.2-43.254-48.789-48.789c-6.875-6.875-6.875-18.02 0-24.894l42.856-42.856c6.875-6.875 18.023-6.875 24.898.004l91.988 92.035zm0 0",
    opacity: 1,
    "data-original": "#76ffd9",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5197ff",
    d: "m400.96 188.262-67.75 67.754-16.433-16.457 67.754-67.754zm0 0",
    opacity: 1,
    "data-original": "#5de0bf",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#434c54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281 238.234 107.781 65.02c-9.785-9.786-25.71-9.79-35.5 0l-42.86 42.855c-4.741 4.742-7.35 11.047-7.35 17.754 0 6.703 2.609 13.008 7.35 17.75l112.61 112.61L29.418 368.62c-9.785 9.79-9.785 25.715.004 35.5l42.855 42.86c4.743 4.742 11.047 7.355 17.75 7.351 6.707 0 13.012-2.61 17.754-7.352L281 273.738c9.785-9.789 9.785-25.715 0-35.504zM97.176 436.375a10.055 10.055 0 0 1-7.59 2.95c-2.621-.11-5.078-1.329-6.938-3.184l-42.62-42.625c-3.938-3.938-3.938-10.348 0-14.29l113.835-113.855c5.078-5.082 5.172-13.285.215-18.48l-1.469-1.54L40.262 133.005c-1.856-1.856-3.075-4.313-3.184-6.938a10.046 10.046 0 0 1 2.95-7.586l42.859-42.855a10.07 10.07 0 0 1 7.144-2.953c2.586 0 5.172.984 7.145 2.953L270.39 248.844c3.941 3.937 3.941 10.347 0 14.289zM483.52 488.582c-4.141 0-7.5 3.36-7.5 7.5v8.418a7.5 7.5 0 1 0 15 0v-8.418a7.5 7.5 0 0 0-7.5-7.5zM439.246 488.582c-4.14 0-7.5 3.36-7.5 7.5v8.418a7.5 7.5 0 1 0 15 0v-8.418a7.5 7.5 0 0 0-7.5-7.5zM394.977 488.582a7.5 7.5 0 0 0-7.5 7.5v8.418a7.5 7.5 0 1 0 15 0v-8.418c0-4.14-3.36-7.5-7.5-7.5zM96.043 23.418a7.5 7.5 0 0 0 7.5-7.5V7.5a7.5 7.5 0 1 0-15 0v8.418c0 4.14 3.36 7.5 7.5 7.5zM51.773 23.418c4.141 0 7.5-3.36 7.5-7.5V7.5a7.5 7.5 0 1 0-15 0v8.418a7.5 7.5 0 0 0 7.5 7.5zM7.5 0C3.36 0 0 3.36 0 7.5v8.418c0 4.14 3.36 7.5 7.5 7.5s7.5-3.36 7.5-7.5V7.5C15 3.36 11.64 0 7.5 0zm0 0",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#434c54",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.379 238.234 288.156 65.02c-9.785-9.786-25.71-9.79-35.5 0l-42.855 42.855c-4.742 4.742-7.356 11.047-7.356 17.754 0 6.703 2.614 13.008 7.356 17.75l112.605 112.61-112.61 112.632c-9.784 9.79-9.784 25.715 0 35.5l42.856 42.86c4.743 4.742 11.047 7.355 17.754 7.351 6.707 0 13.008-2.61 17.75-7.352l173.219-173.242c9.79-9.789 9.79-25.715.004-35.504zM277.55 436.375a10.046 10.046 0 0 1-7.586 2.95c-2.625-.11-5.082-1.329-6.938-3.184l-42.625-42.625c-3.937-3.938-3.937-10.348 0-14.29l112.825-112.843c5.832-5.836 5.726-15.328-.239-21.031L220.641 133.004c-1.86-1.856-3.075-4.313-3.188-6.938a10.064 10.064 0 0 1 2.953-7.586l42.856-42.855c1.968-1.969 4.558-2.953 7.144-2.953s5.176.984 7.145 2.953L450.77 248.844c3.937 3.937 3.937 10.347 0 14.289zm0 0",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#434c54",
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferRightArrow);
export default __webpack_public_path__ + "static/media/transfer-right-arrow.d2dd763337cd3b7be46736bd5d66eb21.svg";
export { ForwardRef as ReactComponent };